/**
 * Link zum Original in DEVONthink (A3, 28.10.2026). Format laut DEVONthink selbst („referenceURL“ eines Datensatzes, gelesen 28.10.2026):
 * `x-devonthink-item://<UUID>`. Nur für eine gültige Kennung — sonst null, damit nie ein beliebiger Text als Link-Schema im href landet.
 * Öffnet auf dem Mac mit DEVONthink; ob der Link auf dem iPhone funktioniert, ist nicht geprüft.
 */
const DT_UUID = /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i;

export function devonthinkLink(uuid: string | null | undefined): string | null {
  return typeof uuid === "string" && DT_UUID.test(uuid) ? `x-devonthink-item://${uuid}` : null;
}
